import { ref, Ref } from "@vue/composition-api";
import { VaultFile } from "@scrile/api-provider/dist/api/VaultsProvider";
import providers from "@/lib/api";
import { FilterSubject, UsedFilesMap } from "@/components/VaultController/types";

export const useVaultFilesStatus = (filterSubject?: Ref<FilterSubject | undefined>) => {
  const usedFilesMap = ref<UsedFilesMap>({});

  const getUnusedFiles = async (
    uuids: VaultFile["uuid"][],
    filterSubject: FilterSubject,
    userId: string
  ): Promise<VaultFile[]> => {
    const response = await providers.VaultsProvider.search({
      data: {
        userId,
        page: 0,
        size: uuids.length,
        unusedIn: filterSubject,
        uuids,
      },
    });
    return response.result;
  };

  const updateUsedFilesMap = async (files: VaultFile[], userId: string): Promise<void> => {
    if (!filterSubject?.value || files.length === 0) return;
    const usedFiles = await getUnusedFiles(
      files.map(i => i.uuid),
      filterSubject.value,
      userId
    );

    const newMapItems = files.reduce<UsedFilesMap>((acc, file) => {
      acc[file.uuid] = !usedFiles.find(i => i.uuid === file.uuid);
      return acc;
    }, {});
    usedFilesMap.value = { ...usedFilesMap.value, ...newMapItems };
  };

  return {
    usedFilesMap,
    updateUsedFilesMap,
  };
};
